import {
    ZXING_WASM_VERSION as DETECTOR_WASM_VERSION,
    prepareZXingModule,
    purgeZXingModule,
} from "barcode-detector/ponyfill"
import { ZXING_WASM_VERSION as BUNDLED_WASM_VERSION } from "zxing-wasm/reader"
import bundledWasmUrl from "zxing-wasm/reader/zxing_reader.wasm"

// The decoder fetches its WebAssembly at runtime, from a CDN by default. Serving our own copy keeps scanning working
// on networks that block the CDN, as long as the copy matches the decoder version the detector was built against;
// on a mismatch, or when the copy fails to load, the CDN copy is used instead.
let modulePromise: Promise<unknown> | null = null

function loadBundledModule(): Promise<unknown> {
    if (DETECTOR_WASM_VERSION !== BUNDLED_WASM_VERSION) {
        return Promise.reject(
            new Error(
                `bundled zxing-wasm ${BUNDLED_WASM_VERSION} does not match the detector's ${DETECTOR_WASM_VERSION}`,
            ),
        )
    }

    return prepareZXingModule({
        overrides: {
            locateFile: (path: string, prefix: string) => (path.endsWith(".wasm") ? bundledWasmUrl : prefix + path),
        },
        fireImmediately: true,
    })
}

export default function prepareCodeDecoder(): Promise<unknown> {
    if (modulePromise === null) {
        modulePromise = loadBundledModule()
            .catch((error: unknown) => {
                console.warn("Falling back to the CDN copy of the barcode decoder:", error)
                purgeZXingModule()

                return prepareZXingModule({ overrides: {}, fireImmediately: true })
            })
            .catch((error: unknown) => {
                // A failed load isn't final (the network may be back next time), so the next call tries again
                modulePromise = null
                throw error
            })
    }

    return modulePromise
}
